import SampleMain from '@/views/sample/Main'
import SampleDetail from '@/views/sample/SampleDetail'
import MainSample from '@/views/sample/MainSample'
import Detail from '@/views/sample/Detail'
import Query from '@/views/sample/Query'
import SampleForm from '@/views/sample/SampleForm'

export default [
  {
    path: "/sample/main",  // 경로
    name: "sample-main",   // 해당 경로의 이름         
    component: SampleMain,
    meta: { auth: false }
  },
  {
    path: "/sample/detail",  // 경로
    name: "sample-detail",   // 해당 경로의 이름         
    component: SampleDetail,
    meta: { auth: false }
  },
  {
    path: "/sample/",      // 경로
    name: "mainSample",   // 해당 경로의 이름         
    component: MainSample,
    meta: { auth: false }
  },
  {
      path: '/detail/:id',
      name: 'detail',
      component: Detail,
      meta: { auth: true }
  },
  {
      path: '/query',
      name: 'query',
      component: Query,
      meta: { auth: true }
  },
  {
      path: '/sampleForm',
      name: 'form',
      component: SampleForm,
      meta: { auth: false }
  },
]